import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getModelData } from '../../Redux/Actions/modelsDataActions';
import { tableFilterChanged } from '../../Redux/Actions/tablesActions';
import ReactTable from 'react-table-6';
import Trash from '../../Components/Trash/Trash';
import Pencil from '../../Components/Pencil/Pencil';

class RightTable extends Component {
  componentDidMount() {
    const { model, onGetModelData } = this.props;
    if (model) {
      onGetModelData(model);
    }
  }

  render() {
    const {
      title,
      data,
      columns,
      model,
      onFilterChanged,
      filtered,
    } = this.props;

    const params = [
      {
        Header: '',
        sortable: false,
        filterable: false,
        width: 50,
        Cell: row => {
          return (
            <div className="parameters">
              <Pencil row={row} model={model} />
              <Trash row={row} model={model} />
            </div>
          );
        },
      },
    ];

    const inputs = columns.concat(params);
    const rows = Object.values(data).filter(row => !row.deleted);
    const count = rows.length;
    return (
      <div className="col-md-8 right-table">
        <div className="panel">
          <div className="panel-body">
            <h3 className="title-hero">{`${title} (${count})`}</h3>
            <ReactTable
              filterable
              defaultFilterMethod={(filter, row) => {
                return String(row[filter.id])
                  .toLowerCase()
                  .includes(filter.value.toLowerCase());
              }}
              //
              onFilteredChange={e => onFilterChanged(e)}
              filtered={filtered}
              //
              data={rows}
              columns={inputs}
            />
          </div>
        </div>
      </div>
    );
  }
}

RightTable.defaultProps = {
  data: {},
  columns: [],
  filtered: [],
};

const mapStateToProps = (state, ownProps) => ({
  data: state.models[ownProps.model],
  filtered: state.tables[ownProps.model],
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onGetModelData: type => dispatch(getModelData(type)),
  onFilterChanged: filter =>
    dispatch(tableFilterChanged(filter, ownProps.model)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RightTable);
